// When building from radix primitives, use this instead of React.forwardRef
// To get type safety directly from radix

import { forwardRef} from 'react'





export const forwardRadix = (c) =>
  forwardRef(c)
